import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const AgentMessageDisplay = ({ command }) => {
  return (
    <Box>
      {/* Direction indicator */}
      {command.to && command.to !== command.source && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight="bold">
            To: {command.to}
          </Typography>
          <KeyboardDoubleArrowRightIcon fontSize="small" sx={{ ml: 0.5, color: 'text.secondary' }} />
        </Box>
      )}
      {/* Content box */}
      <Box
        sx={{
          borderLeft: '4px solid',
          borderColor: 'info.main', // Default for agent messages
          pl: 2,
          py: 0.5,
          backgroundColor: 'action.hover',
          borderRadius: '0 4px 4px 0',
        }}
      >
        <Typography variant="body2">
          {typeof command.content === 'object' ? JSON.stringify(command.content) : command.content}
        </Typography>
      </Box>
    </Box>
  );
};

AgentMessageDisplay.propTypes = {
  command: PropTypes.shape({
    content: PropTypes.any,
    source: PropTypes.string,
    to: PropTypes.string,
  }).isRequired,
};

export default React.memo(AgentMessageDisplay);